"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _getValidObject = _interopRequireDefault(require("../../get-valid-object"));

var DEFAULT_UNIT_LABEL = '';
/**
 * A class to represent the visualization options for Number 
 * @param {object} options - options object (See below)
 * @param {string} [options.unit = ''] - The unit label to be displayed
 *
 * @property {string} unit - The label to display as the unit
 */

var MwNumberOptions = function MwNumberOptions(options) {
  (0, _classCallCheck2.default)(this, MwNumberOptions);
  var safeOptions = (0, _getValidObject.default)(options);

  if (safeOptions.unit === undefined) {
    safeOptions.unit = DEFAULT_UNIT_LABEL;
  } else {
    _argumentContracts.default.assertString(safeOptions.unit, 'options.unit');
  }

  this.unit = safeOptions.unit;
  Object.freeze(this);
};

exports.default = MwNumberOptions;